module.exports = __webpack_public_path__ + "static/media/colizone.d8960240.webp";